module.exports = __webpack_public_path__ + "img/yd6@2x.021abbfd.png";